// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"006fe28f","195":"11eb10ed","287":"216e08ff","341":"b934063d","678":"b8fc212d","840":"ae3534f6"}[chunkId] + ".chunk.js";
};